// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CustomCheckBox_Wrapper__TeCfq","Text":"CustomCheckBox_Text__G_6hf"};